/* Native details adds subpages without replacing the existing mobile-menu or cart contracts. */
(function () {
  'use strict';
  function init() {
    var header = document.querySelector('[data-cebe-header]');
    if (!header || header.hasAttribute('data-cebe-navigation-ready')) return;
    header.setAttribute('data-cebe-navigation-ready', '');
    var groups = Array.prototype.slice.call(header.querySelectorAll('[data-cebe-nav-group]'));
    var desktop = window.matchMedia('(min-width: 1001px)');
    var desktopNav = header.querySelector('.cebe-header__nav');
    var hoverStates = [];
    function cancelHover(state) {
      if (!state) return;
      window.clearTimeout(state.openTimer);
      window.clearTimeout(state.closeTimer);
      state.openTimer = null;
      state.closeTimer = null;
    }
    function cancelAllHover() {
      hoverStates.forEach(cancelHover);
    }
    function desktopGroup(group) {
      return desktop.matches && desktopNav && desktopNav.contains(group);
    }
    function anotherGroupHasKeyboardFocus(group) {
      var active = document.activeElement;
      if (!active || (active.tagName === 'SUMMARY' && !active.matches(':focus-visible'))) return false;
      var scope = group.closest('[data-cebe-nav-scope]');
      return groups.some(function (other) {
        return other !== group && other.open && scope.contains(other) && other.contains(active);
      });
    }
    groups.forEach(function (group) {
      var state = { group: group, openTimer: null, closeTimer: null, openedByHover: false, pointerDown: false, navigateOnClick: false };
      hoverStates.push(state);
      group.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse' || !desktopGroup(group)) return;
        window.clearTimeout(state.closeTimer);
        state.closeTimer = null;
        if (group.open) return;
        window.clearTimeout(state.openTimer);
        state.openTimer = window.setTimeout(function () {
          state.openTimer = null;
          if (!desktopGroup(group) || !group.matches(':hover') || anotherGroupHasKeyboardFocus(group)) return;
          if (document.documentElement.classList.contains('cebe-search-open')) return; // K789 I-13: no hidden panel behind the search
          state.openedByHover = true;
          group.open = true;
        }, 150);
      });
      group.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'mouse' || !desktopGroup(group)) return;
        window.clearTimeout(state.openTimer);
        state.openTimer = null;
        if (!group.open) return;
        window.clearTimeout(state.closeTimer);
        state.closeTimer = window.setTimeout(function () {
          state.closeTimer = null;
          if (!desktopGroup(group) || group.matches(':hover') || group.contains(document.activeElement)) return;
          group.open = false;
        }, 250);
      });
      group.addEventListener('pointerdown', function (event) {
        cancelHover(state);
        state.pointerDown = event.button === 0;
        state.navigateOnClick = !!event.target.closest('summary') && event.pointerType === 'mouse' && event.button === 0 && desktopGroup(group);
      });
      group.querySelector('summary').addEventListener('click', function (event) {
        if (state.navigateOnClick && event.detail > 0) {
          var overview = group.querySelector('.cebe-nav-panel a[href]');
          if (overview) {
            event.preventDefault();
            window.location.assign(overview.href);
          }
        }
        state.navigateOnClick = false;
        state.openedByHover = false;
      });
      group.addEventListener('toggle', function () {
        if (!group.open) {
          cancelHover(state);
          state.openedByHover = false;
          state.navigateOnClick = false;
          return;
        }
        var scope = group.closest('[data-cebe-nav-scope]');
        Array.prototype.forEach.call(scope.querySelectorAll('[data-cebe-nav-group]'), function (other) {
          if (other !== group && other.open) {
            cancelHover(hoverStates[groups.indexOf(other)]);
            other.open = false;
          }
        });
        if (desktopGroup(group) && window.cebe && window.cebe.closeSearch) window.cebe.closeSearch();
      });
      group.addEventListener('focusout', function () {
        var pointerFocusOut = state.pointerDown;
        window.setTimeout(function () {
          if (!pointerFocusOut && !state.pointerDown && !group.contains(document.activeElement)) group.open = false;
        }, 0);
      });
    });
    function releasePointers() {
      hoverStates.forEach(function (state) { state.pointerDown = false; });
    }
    document.addEventListener('pointerup', releasePointers, true);
    document.addEventListener('pointercancel', releasePointers, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') releasePointers();
    }, true);
    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      cancelAllHover();
      var group = event.target.closest('[data-cebe-nav-group]');
      if (!group || !group.open) return;
      group.open = false;
      group.querySelector('summary').focus();
      event.preventDefault();
      event.stopPropagation();
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      cancelAllHover();
      hoverStates.forEach(function (state) {
        if (state.openedByHover && state.group.open && !state.group.contains(document.activeElement)) {
          state.group.open = false;
        }
      });
    });
    document.addEventListener('click', function (event) {
      cancelAllHover();
      groups.forEach(function (group) {
        if (!group.contains(event.target)) group.open = false;
      });
    });
    var menu = header.querySelector('[data-cebe-menu]');
    if (menu && window.MutationObserver) {
      new MutationObserver(function () {
        if (!menu.hidden) return;
        groups.forEach(function (group) {
          if (menu.contains(group)) group.open = false;
        });
      }).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
    }
    desktop.addEventListener('change', function () {
      cancelAllHover();
      groups.forEach(function (group) { group.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
